/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2025/5/21      1.0     First version
 *
 * 注意：
 * maxCount 最多选择项数
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React, {PureComponent} from "react";
import {Spin,Button,Tooltip,Radio } from 'antd';
import Lang from "@components/Lang/Lang";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import CategoryLimitSelector from "@components/CategorySelector/CategoryLimitSelector";
import Locale from "@utils/locale";
import "./index.less";
const RadioGroup = Radio.Group, RadioButton = Radio.Button;
const config = require("@config/config");
export default class FactList extends PureComponent {
    // static defaultProps = {
    //     orderModel: {}, // 显示
    // };
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            pageConf:{
                pageSize:50,
                facFilterForm: [ // row 1：全， 2 不占满
                    {
                        name:"工厂优势 ",
                        key:"factoryAdvantages",
                        type:'DictOption',
                        dict:'sup_supplier_extend_factory_advantages',
                    },{
                        name:"销售类型 ",
                        key:"saleType",
                        type:'DictOption',
                        dict:'sale_type',

                    }, {
                        name:"工厂类型",
                        key:"sourceFactoryType",
                        type:'DictOption',
                        dict:'sup_supplier_source_factory_type'
                    },
                ],
                factInfo: [//工厂信息
                    {
                        name:"主营类目 ",
                        key:"mainCategoryName",
                        type:'tips'
                    },{
                        name:"销售类型 ",
                        key:"saleTypeName",
                    }, {
                        name:"工厂类型",
                        key:"sourceFactoryTypeName",
                    },{
                        name:"工厂优势 ",
                        key:"factoryAdvantagesName",
                    }, {
                        name:"企业证书",
                        key:"supplierCertification",
                    },
                ],
            }
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求地区列表
     * */
    getList(pageIndex,pageSize){
        this.loading(true)
        this.onRefAutoFetchListChrld.handleFetch(1,false);
    }
    /**
     * 渲染一个工厂
     * */
    renderOne(item,inx){
        const {loading = true,list=[],pageConf} = this.state;
        const bpmsUrl =  config.servers[config.environment].bpmsUrl;
        return (<div className="factCard flex-item-between" key={'re_'+inx}>
            <div className="flex-item flex-1">
                <div className="factLeft">
                    <div className="mb_8 font_18 fw_700 ellipsis">{item.supplierName}</div>
                    <div className="black66 mb_8">{item.supplierCode}</div>
                    <div className="black66">
                        <Button className={"ant-btn-primary-blue"}
                                target="_blank"
                                href={bpmsUrl+'/#/main/viewSupplier/'+item.supplierId}>{Lang({id: "ChaKan",default: "查看"})}</Button>
                    </div>
                </div>
                <div className="factInfo flex-1">
                    {pageConf.factInfo.map((filed,inxFiled)=><div className="mb_8 flex-item" key={inxFiled+'_f'}>
                        <span className="black45">{filed.name}</span>
                        {filed.type=='tips'?<Tooltip title={item[filed.key]} placement="topLeft">
                            <span className="factInfoV flex-1 ellipsis" >{item[filed.key] || '-'}</span>
                        </Tooltip>:<span className="factInfoV flex-1 ellipsis" >{item[filed.key] || '-'}</span>}
                    </div>)}
                </div>
            </div>
            {item.skuList&&item.skuList.length>0?<div className="flex-item">
                {item.skuList.map((sku,sInx)=><div className="skuPicBox" key={sInx+'_sk'}>
                    <a target="_blank" className="skuPic" href={bpmsUrl+'/#/main/sku-view/'+sku.skuId}>
                        <img src={sku.skuFileUrl} />
                    </a>
                    <a target="_blank" className="ellipsis-line2 black100" href={bpmsUrl+'/#/main/sku-view/'+sku.skuId}>{sku.skuName}</a>
                </div>)}
            </div>:null}
        </div>)
    }
    changeFilter(key,value){
        let {queryFact={}} = this.state;
        if(queryFact[key]==value){
            delete queryFact[key];
        }else {
            queryFact[key] = value;
        }
        this.setState({
            queryFact:{...queryFact},
        },()=>{
            this.getList(1)
        })
    }
    /*
    * 获取字典
    * */
    getDict(key){
        let {pageConf={}} = this.state;
        const dList =__getDictList(key)||[];
        let options= [];
        dList.forEach(item=>options.push({label:item.name,value:item.code+""}));
        pageConf[key] = options;
        this.setState({
            pageConf: pageConf
        })
    }
    /**
     * 重置
     **/
    searchReset(){
       this.setState({
           queryFact:{}
       },()=>{
           this.getList(1)
       })
    }
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChrld = ref;
    componentWillMount() {
        this.getDict("sup_supplier_extend_factory_advantages");
        this.getDict("sale_type");
        this.getDict("sup_supplier_source_factory_type");
    }
    componentDidMount() {
        if (this.props.onRef) this.props.onRef(this);
    }

    render() {
        const {loading = false,list=[],pageConf={},queryFact={}} = this.state;
        return (<Spin spinning={loading}>
            <div className={'flex-item'}>
                <CategoryLimitSelector maxCount={5} onChange={(value)=>this.changeFilter('mainCategoryIds',value)} checkedKeys={queryFact.mainCategoryIds||[]}/>
                {pageConf.facFilterForm.map((field,inx)=>{
                      if(field.key!='sourceFactoryType'||(field.key=='sourceFactoryType'&&queryFact.saleType=='1')){
                            return (<RadioGroup className={"ml_8"}
                                                options={pageConf[field.dict]} key={field.key+"_"+inx}
                                                onClick={(e)=>console.log(e)}
                                                onChange={(e)=>this.changeFilter(field.key,e.target.value)}
                                                value={queryFact[field.key]}
                                                optionType="button" />)
                        }
                })}
                <Button className={"ml_8"} type="primary" onClick={()=>this.searchReset()} loading={loading}>
                    {Lang({id:'ZhongZhi',default:'重置'})}
                </Button>
            </div>
            <div className="recommendFactoryWrap black89">
                <AutoFetchList onRef={this.onRefAutoFetchList}
                               fetchCallBack={(data)=>this.loading(false)}
                               showTotal={false}
                               pageSize={50}
                               precondition={{
                                   businessPlatform: 'essaone',
                                   lang: Locale.current(),
                                   ...queryFact
                               }}
                               fetchApi={"/service/mg/fuzzy/recommend-factory/query-list"}
                               renderList={(item,inx)=>this.renderOne(item,inx)} />


            </div>
        </Spin>);
    }
}
